module.exports = __webpack_public_path__ + "img/mail.7610e203.svg";